import axios from "axios";

// Configurações padrão para desabilitar cache em todas as requisições HTTP do Axios
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = '0';

function getApiBase() {

    const apiEstatica = process.env.REACT_APP_DADOS_ESTATICOS === 'true';

    if (apiEstatica) {
        return process.env.PUBLIC_URL;
    }

    return process.env.REACT_APP_API_URL;
}

function getHeaders(modulo) {

    modulo = modulo ?? 'public';
    let token = sessionStorage.getItem('token');

    let headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
    };

    if (token) {

        const credentials = Buffer.from(token, 'base64').toString('utf-8');
        const [username] = credentials.split(':');

        if (username === modulo) {
            headers["x-api-token"] = token;
        }

    }

    return headers;
}

export const authenticate = (modulo, password) => {

    if (!password) {
        password = "";
    }

    const apiEstatica = process.env.REACT_APP_DADOS_ESTATICOS === 'true';

    if (apiEstatica) {

        if (modulo === "GPR" && password === process.env.REACT_APP_PASS_GPR) {
            const userinfo = Buffer.from(`${modulo}:${password}`, 'utf-8').toString('base64');
            return Promise.resolve({
                data: {
                    token: userinfo
                }
            });
        }
        if (modulo === "GPRF" && password === process.env.REACT_APP_PASS_GPRF) {
            const userinfo = Buffer.from(`${modulo}:${password}`, 'utf-8').toString('base64');
            return Promise.resolve({
                data: {
                    token: userinfo
                }
            });
        }

        return Promise.reject("Usuário/senha inválidos.");
    }

    const headers = getHeaders(modulo);
    return axios.post(`${process.env.REACT_APP_API_URL}/auth`, null, {
        headers,
        auth: {
            username: modulo,
            password: password
        }
    });
}

export const getLocalidades = (modulo) => {

    const apiEstatica = process.env.REACT_APP_DADOS_ESTATICOS === 'true';
    const headers = getHeaders(modulo);

    if (apiEstatica) {
        return axios.get(`${getApiBase()}/docs/dados_estaticos/localidade.json`, { headers });
    }

    return axios.get(`${getApiBase()}/localidade`, { headers, withCredentials: true });
}

export const getLocalidade = (cod, modulo) => {

    const apiEstatica = process.env.REACT_APP_DADOS_ESTATICOS === 'true';
    const headers = getHeaders(modulo);

    if (apiEstatica) {
        const prefix = modulo ? modulo.toLowerCase() : "public";
        return axios.get(`${getApiBase()}/docs/dados_estaticos/localidade_${prefix}_${cod.value}.json`, { headers });
    }

    let promise = axios.get(`${process.env.REACT_APP_API_URL}/ze/` + cod.value, { headers, withCredentials: true });

    return promise;
}

export const apiDoc = (docUrl) => {

    if (docUrl.startsWith("{api}")) {

        const apiEstatica = process.env.REACT_APP_DADOS_ESTATICOS === 'true';

        if (apiEstatica) {
            docUrl = docUrl.replace('{api}', `${getApiBase()}/docs`);
        }

        docUrl = docUrl.replace('{api}', `${process.env.REACT_APP_API_URL}/doc/${process.env.REACT_APP_DOCS_GPRF_HASH}`);
    }

    return docUrl;
}